import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthHttp } from './../../core/auth-http.service';
import { Headers, Http, RequestMethod } from '@angular/http';
import { Observable, } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Session } from './../../users/user.types';
import 'rxjs/add/operator/mergeMap';

@Injectable()
export class ConfigService {
  constructor(
    private router: Router,
    private http: AuthHttp
  ) {}
  //-------------------------------------------------------------------------------------------------------------------
  /**
   * make secure api-request mit pre-check for login and admin-flags
   * -> on failure exception will be raised and router navigates back home (eg login)
   * @param method request-method
   * @param apiUrl api-url
   */
  secureRequest(method: RequestMethod, apiUrl: String, data?: any): any {
    // get session id from storage
    const sid = localStorage.getItem('sessionId');
    // define custom session-header
    const headers = new Headers(); if(sid){ headers.append('Bonanza-Session-Id',sid); }
    // returns first observable for security-check, returns internally second observable from api-request
    return this.http.get(environment.apiBaseUrl+'user/sessionData', { headers: headers })
      .map((response: any) => response.json())
      .flatMap((session: Session): any => {
        // check if user is logged in
        if(session.isLoggedIn!==true){ 
          this.routeHome(); throw new Error('User not logged in');
        }
        // check is user is admin or sysadmin and serverAdmin-Flag=true
        if((session.isServerAdmin!==true)||((session.groups.indexOf('admin')===-1)&&(session.groups.indexOf('sysadmin')==-1))){
          this.routeHome(); throw new Error('User is no admin');
        }
        // 
        let retObservable = null;
        // switch request method and return second observable from api-request
        switch(method){
          case RequestMethod.Delete:  
            retObservable = this.http.delete(environment.apiBaseUrl+apiUrl, {headers: headers})
              .map( (response: any) => response.json() ); break;
          case RequestMethod.Get:     
            retObservable = this.http.get(environment.apiBaseUrl+apiUrl, {headers: headers})
              .map( (response: any) => response.json() ); break;
          //case RequestMethod.Head:    methodStr = 'head'; break;
          //case RequestMethod.Options: methodStr = 'options'; break;
          //case RequestMethod.Patch:   methodStr = 'patch'; break;
          case RequestMethod.Post:    
            retObservable = this.http.post(environment.apiBaseUrl+apiUrl, data, { headers: headers })
              .map( (response) => response.json() ); break;
          case RequestMethod.Put:
            retObservable = this.http.put(environment.apiBaseUrl+apiUrl, data, { headers: headers })
              .map( (response) => response.json() ); break;
        }
        return retObservable;
      });
  }
  //-------------------------------------------------------------------------------------------------------------------
  /**
   * instructs router to go back home (eg login)
   */
  routeHome(): void {
    this.router.navigate(['/']);
  }
  //-------------------------------------------------------------------------------------------------------------------
}



// WEBPACK FOOTER //
// ./src/app/config/services/config.service.ts